const TEN_MINUTES_IN_MILLIS = 600000;

export function isBrowser() {
  return typeof window !== 'undefined';
}

/********************************************************************************
 * token refresh interval singleton only allows one instance to ever be created *
 *******************************************************************************/
export const setTokenRefreshInterval = (() => {
  let sessionInterval = null;

  return {
    // tokenRefreshRate needs to be less than 59 minutes
    getInstance({
      user,
      refreshTheToken,
      currentExpiration,
      tokenRefreshRate = TEN_MINUTES_IN_MILLIS,
    }) {
      // currentExpiration is in seconds. Convert to milliseconds and subtract the current time to get correct milliseconds before token expires
      const tokenTimeRemaining = currentExpiration * 1000 - Date.now();
      if (tokenTimeRemaining < tokenRefreshRate) {
        refreshTheToken({ user });
        console.info(
          `token has been refreshed due to the current expiration time ${currentExpiration} is before the scheduled refresh`
        );
      }
      if (sessionInterval) return sessionInterval;
      else {
        sessionInterval = setInterval(() => {
          refreshTheToken({ user });
        }, tokenRefreshRate);
        console.info(
          `token refresh interval ID:${sessionInterval} is every ${tokenRefreshRate} milliseconds`
        );
        return sessionInterval;
      }
    },
  };
})();

export const capitalize = (str) => str[0].toUpperCase() + str.slice(1);

export function getFeatureFlag({ name }) {
  const flag = localStorage.getItem(name);
  return flag === 'true';
}

export const formatAmount = (amount, digits) => {
  const number = Number(amount).toFixed(digits);

  // Convert the fixed-point number to a string to avoid scientific notation
  const parts = number.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  // If there's a decimal part, remove trailing zeros
  if (parts[1]) {
    parts[1] = parts[1].replace(/0+$/, ''); // Remove trailing zeros
    if (parts[1] === '') {
      parts.pop(); // Remove the decimal part if it's empty
    }
  }

  return parts.join('.');
};

export const toDollar = (amount) =>
  amount?.toLocaleString('en-US', {
    currency: 'USD',
    style: 'currency',
  });

export const handleCopyClick = (copyText, setIsCopied) =>
  navigator.clipboard.writeText(copyText).then(() => {
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1600);
  });
// .catch((error) => {
//   console.log(error);
// });

export const formatDate = (date, size = 'long', withTime) => {
  const timestamp = new Date(date);
  return withTime
    ? timestamp.toLocaleString('en-US', {
        dateStyle: size,
        timeStyle: size,
      })
    : timestamp.toLocaleString('en-US', {
        year: 'numeric',
        month: size,
        day: 'numeric',
      });
};

export const shortenString = (
  str,
  maxCharacterPerSide,
  middleText = '...',
  ifEmptyText = ''
) => {
  if (str) {
    if (str.length <= maxCharacterPerSide * 2) {
      return str;
    } else {
      return (
        str.slice(0, maxCharacterPerSide) +
        middleText +
        str.slice(maxCharacterPerSide * -1)
      );
    }
  } else {
    return ifEmptyText;
  }
};

export const formatPhone = (phone) => {
  if (phone.charAt(1) === '1') {
    return phone?.replace(/(\W{1})(\d{1})(\d{3})(\d{3})(\d{4})/, '$1 $2 ($3) $4-$5');
  } else {
    return phone;
  }
};

export function formatWalletAddress(address, start = 5, end = 4) {
  const first = address?.slice(0, start);
  const last = address?.substring(address?.length - end);
  return `${first}...${last}`;
}

export function scrollOnPage(hash) {
  const element = document.getElementById(hash);

  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
}
